import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { buttonText } from "../../utils/buttonText";
import { pageText } from "../../utils/pageText";

function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div>
      <h1>{pageText("404 Page Not Found")}</h1>
      <p>{pageText("Please check if the url path is correct.")}</p>
      <Button onClick={() => navigate("/acquisition")}>{buttonText("Go to DAAT")}</Button>
    </div>
  );
}

export default NotFoundPage;
